import moment from "moment";
import { BaseEntity } from ".";
import { IGet_characters_character_id_skillqueue_200_ok } from "../service/esiclient";
import { getCachedTypeEntity } from "./TypeEntityCache";

export class SkillQueueEntity extends BaseEntity {
  constructor(id: number, props: any) {
    super(id, props);
    this._dataTypeName = "Skill Queue Entry";
  }

  async toJson(): Promise<Excel.EntityCellValue> {
    const props: Partial<IGet_characters_character_id_skillqueue_200_ok> = this.props;
    var entity = await super.toJson();

    // Properties
    if (entity.properties) {
      // - Id
      if (Object.prototype.hasOwnProperty.call(entity.properties, "skill_id")) {
        delete entity.properties.skill_id;
      }
      // - Name
      let name = "(Unknown)";
      let level = "";
      if (props.skill_id) {
        const typeEntity = await getCachedTypeEntity(props.skill_id);
        if (typeEntity != null) {
          entity.properties["name"] = {
            type: Excel.CellValueType.string,
            basicValue: typeEntity.props.name,
          };
          name = typeEntity.props.name;
        }
        if (props.finished_level) {
          level = " " + props.finished_level.toString();
        }
        entity.text = name + level;
      }
      if (props.start_date) {
        const startdate = moment(props.start_date);
        entity.properties["start_date"] = {
          type: Excel.CellValueType.formattedNumber,
          basicValue: startdate.unix() / 86400 + 25569,
          numberFormat: "[$-409]m/d/yy h:mm AM/PM;@",
        };
      }
      if (props.finish_date) {
        const finishdate = moment(props.finish_date);
        entity.properties["finish_date"] = {
          type: Excel.CellValueType.formattedNumber,
          basicValue: finishdate.unix() / 86400 + 25569,
          numberFormat: "[$-409]m/d/yy h:mm AM/PM;@",
        };
      }
    }

    // Layouts
    entity.layouts = {
      card: {
        title: { property: "name" },
      },
    };

    return entity;
  }
}
